import React from "react";
import { Box, Typography } from "@mui/material";
import styled from "@emotion/styled";
import { ASSETS } from "../../../utils/config";
import { ReactComponent as PrimaryWheelPlacehodlerImage } from "../../../assets/images/primaryWheelPlaceholderImage.svg";

const CardContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 10px;
  width: 100%;
  height: 100%;
  // background: linear-gradient(
  //     0deg,
  //     rgba(255, 255, 255, 0.5),
  //     rgba(255, 255, 255, 0.5)
  //   ),
  //   conic-gradient(
  //     from 180deg at 50% 50%,
  //     #f5eede -41.73deg,
  //     #ccfeff 37.8deg,
  //     #f7fed5 140.4deg,
  //     #fdcffe 216deg,
  //     #f5eede 318.27deg,
  //     #ccfeff 397.8deg
  //   );
  background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0) 30%,
      rgba(255, 255, 255, 1) 53%,
      rgba(255, 255, 255, 1) 100%
    ),
    linear-gradient(
      134.14deg,
      #ccfeff 4.01%,
      #f7fed5 16.16%,
      #fdcffe 32.48%,
      #f5eede 54.56%
    );
  margin: 0;
  border-radius: 8px;
  overflow-x: hidden;
  box-sizing: border-box;
`;

const ContentWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 24px;
  gap: 24px;
  flex: 1;
`;

const ContentBox = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 16px 24px;
  gap: 8px;
  height: 196px;
`;

const Title = styled(Typography)`
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #344054;
  margin-bottom: 8px;
`;

const Description = styled(Typography)`
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #565556;
`;

const PrimaryWheelPlaceHolder = () => {
  return (
    <CardContainer>
      <ContentWrapper>
        <PrimaryWheelPlacehodlerImage
          style={{ width: "180px", height: "180px" }}
        />
        <ContentBox>
          <Title>Your Primary Wheel!</Title>
          <Description>
            Showcase your best Wheel here for all the world to see.
          </Description>
        </ContentBox>
      </ContentWrapper>
    </CardContainer>
  );
};

export default PrimaryWheelPlaceHolder;
